import React, { useEffect, useState } from 'react';
import CalenderViewComponent from '../CalenderView/CalenderViewComponent';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_NOTIFICATION, WFHAttribute } from '../../../constants';
import { getUserData } from '../../../services/UserService';
import { getHRWFHRequests } from '../../../hr/services/LeaveService';
import { setFilterDataState } from '../../../modules/filter/filterAction';
import KeycloakService from '../../../services/KeycloakService';
import GenericLoader from '../../../components/Loader/GenericLoader';

function EmployeeWfhSummaryComponent() {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.filterState);

  const [wfhList, setWfhList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const currentUserId = KeycloakService.getUserDetail();
  const [flagResetFilter, setFlagResetFilterData] = useState(false);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const empName = async (request, id) => {
    const userData = await getUserData(id);
    request.empName = `${userData.data.firstName} ${
      userData.data?.lastName || ''
    }`;
    request.photo = userData.photo;
  };

  const getWfhList = async () => {
    const wfhRequests = await getHRWFHRequests(currentUserId, state);
    if (wfhRequests?.isError === false) {
      await Promise.all(
        wfhRequests.data.data.content.map(async (request) => {
          await empName(request, request.employeeId);
        }),
      );
      const filteredData = wfhRequests.data.data.content.filter(
        (item) =>
          item.status === 'APPROVED' ||
          item.status === 'TASK_PENDING' ||
          item.status === 'TASK_APPROVED',
      );
      setWfhList(filteredData);
      setLoader(false);
    }
    if (wfhRequests.status !== 200) {
      dipatchNotification(wfhRequests.type, wfhRequests.message);
    }
  };

  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const resetFilter = () => {
    const date = new Date();
    dispatch(
      setFilterDataState({
        startDate: formatDateToYYYYMMDD(date),
        endDate: formatDateToYYYYMMDD(date),
        status: '',
      }),
    );
    setFlagResetFilterData(true);
  };

  useEffect(() => {
    resetFilter();
    setFlagResetFilterData(true);
  }, []);

  useEffect(() => {
    if (flagResetFilter) {
      getWfhList();
    }
  }, [state, flagResetFilter]);

  return (
    <>
      {loader ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <CalenderViewComponent type={'wfh'} data={wfhList} />
      )}
    </>
  );
}

export default EmployeeWfhSummaryComponent;
